"use client"

import { useFormContext } from "react-hook-form"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import FormYesNoInput from "@/shared/components/form-inputs/form-yes-no-input"
import HomeDetailsWrapper from "../home-details-wrapper"
import FormTextInput from "@/shared/components/form-inputs/form-text-input"

const baseFieldName = "home.homeStatusInfo"

function RegisterHomeForm2() {
    const { control } = useFormContext<HomeWithHomeOwnerFormType>()
    return (
        <div className="space-y-5">
            <HomeDetailsWrapper heading="Home Status Info">

                <FormYesNoInput
                    inputGroupProps={{
                        label: "Is There Known Lead Paint in Home?"
                    }}
                    name={`${baseFieldName}.leadPaint`}
                    control={control}
                />

                <FormYesNoInput
                    inputGroupProps={{
                        label: "Is the roof currently leaking?"
                    }}
                    name={`${baseFieldName}.roofLeaking`}
                    control={control}
                />

                <FormYesNoInput
                    inputGroupProps={{
                        label: "Is the home currently occupied?"
                    }}
                    name={`${baseFieldName}.CurrentlyOccupied`}
                    control={control}
                />

                <FormTextInput
                    inputGroupProps={{
                        label: "What are Your Primary Needs Right Now",
                    }}
                    placeholder="Enter Your Primary Needs Right Now"
                    name={`${baseFieldName}.primaryneeds`}
                    control={control}
                />
            </HomeDetailsWrapper>
        </div>
    )
}

export default RegisterHomeForm2
